// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.align-container-center {
  /*align-self: "stretch";*/
  align-content: center;
}

.container-center-horizontal {
  display: flex;
  justify-content: center;
}

.container-center-vertical {
  display: flex;
  align-items: center;
}

.btn-own-orange {
  background-color: #cc7d2e;
  color: white;
}
.btn-own-orange:hover {
  background-color: #cc7d2e; /* Background color on hover */
}

.btn-own-yellow {
  background-color: yellow;
  color: black;
}
.btn-own-yellow:hover {
  background-color: yellow; /* Background color on hover */
}

.btn-own-purple {
  background-color: #8e51ff;
  color: white;
}

.btn-own-purple:hover {
  background-color: #8e51ff; /* Background color on hover */
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/formsCommons.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB,EAAE,8BAA8B;AAC3D;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,wBAAwB,EAAE,8BAA8B;AAC1D;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;AAC3D","sourcesContent":[".align-container-center {\n  /*align-self: \"stretch\";*/\n  align-content: center;\n}\n\n.container-center-horizontal {\n  display: flex;\n  justify-content: center;\n}\n\n.container-center-vertical {\n  display: flex;\n  align-items: center;\n}\n\n.btn-own-orange {\n  background-color: #cc7d2e;\n  color: white;\n}\n.btn-own-orange:hover {\n  background-color: #cc7d2e; /* Background color on hover */\n}\n\n.btn-own-yellow {\n  background-color: yellow;\n  color: black;\n}\n.btn-own-yellow:hover {\n  background-color: yellow; /* Background color on hover */\n}\n\n.btn-own-purple {\n  background-color: #8e51ff;\n  color: white;\n}\n\n.btn-own-purple:hover {\n  background-color: #8e51ff; /* Background color on hover */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
